<template>
  <div class="container">
    <!-- 搜索框 -->
    <section class="search_box">
      <section class="search_box_inpt">
        <img class="search_icon" src="../../assets/images/search.png" />
        <input type="text" placeholder="搜索政策关键字" v-model="key" @input="inputFun" autofocus :focus="focus" />
        <img
          class="clear_img"
          @click.stop="searchClear"
          v-if="key.length"
          src="../../assets/images/btn_clear.png"
        />
      </section>
      <span class="search_btn" @click="goback">取消</span>
    </section>
    <!-- 搜索结果 -->
    <section class="search_main">
      <section class="list_item" v-for="(item,index) in dataList" :key="index"  @click="toPolicyDetail(item.id)">
        <h2 class="over_two_lines">{{item.title}}</h2>
        <section class="item_bottom">
          <p class="item_bottom_left">{{item.createTime | timeType}}</p>
          <section class="item_bottom_labal">
            <span v-for="cur in item.tagName" :key="cur"># {{cur}}</span>
          </section>
        </section>
      </section>
      <!-- 搜索结果显示 -->
      <span class="search_status" v-if="searchEnd == '1' && key.length != 0">无搜索结果</span>
      <section class="search_loading" v-if="searchEnd == '2' && key.length != 0">
        <img class="search_icon" src="../../assets/images/icon_loading.png" />
        <span>正在搜索...</span>
      </section>
    </section>
  </div>
</template>

<script>
import util from "../../utils/util";
import { getPolicyByTypeCode } from "../../utils/api";
import { mapState } from "vuex";
let timer = "";
export default {
  name: "policySearch",
  data() {
    return {
      focus: true,
      key: "",
      typeCode: "", //是否是某个模块进来的搜索
      dataList: [],
      pageNo: 1,
      pageSize: 10,
      searchEnd: 0 //搜索结果状态
    };
  },
  filters:{
    timeType(val){
      return util.formatTime(new Date(Number(val)),4)
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.typeCode = this.$route.query.typeCode || "";
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    // 点击清空图标
    searchClear() {
      this.key = "";
      this.searchEnd = 0;
      this.dataList = [];
    },
    inputFun() {
      //键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
      that.dataList = [];
      if (that.key.length === 0 && that.key.length === 0) {
        //如果输入框为空
        that.searchEnd = 0;
      } else {
        this.searchEnd = 2;
        timer = setTimeout(function() {
          that.getData();
        }, 800);
      }
    },
    toPolicyDetail(id){
      this.$router.push(`/policyDetail?id=${id}`);
    },
    getData() {
      //得到配置数据函数
      var that = this;
      let params = {
        typeCode: this.typeCode,
        marketId: this.common.marketInfo.id,
        title: this.key,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      getPolicyByTypeCode(params).then(res => {
        console.log(res);
        if (
          res.res.code === 10000 &&
          res.body &&
          res.body.page &&
          res.body.page.rows
        ) {
          let dataList = res.body.page.rows || [];
          dataList.forEach(item => {
            if(item.tagName){
              item.tagName = item.tagName.split(/[\s+,，]/g).slice(0,2)
            }
          });
          that.searchEnd = 0;
          if (this.pageNo === 1) {
            this.dataList = dataList;
          } else {
            this.dataList = [...this.dataList, ...dataList];
          }
        } else {
          that.searchEnd = 1;
        }
        util.hideLoading();
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.search_box {
  margin: 26px 0 26px 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 68px;
  .flex();
  align-items: center;
  .search_btn {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    display: block;
    padding: 0 32px 0 40px;
  }
  .search_box_inpt {
    flex: 1;
    height: 68px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    position: relative;
    .flex();
    align-items: center;
    .search_icon {
      width: 44px;
      height: 44px;
      display: block;
      margin: 0 14px;
    }
    input {
      flex: 1;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      background: transparent;
      height: 68px;
    }
    .clear_img {
      position: absolute;
      width: 44px;
      height: 44px;
      padding: 12px;
      top: 0;
      right: 0;
    }
  }
}
.search_main {
  margin-top: 120px;
  .search_status {
    display: block;
    text-align: center;
    margin-top: 28px;
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
    line-height: 40px;
  }
  .search_loading {
    margin-top: 28px;
    .flex();
    justify-content: center;
    img {
      display: block;
      width: 32px;
      height: 32px;
      margin-right: 14px;
      animation: loading 1.4s linear infinite;
    }
  }
}
@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.list_item {
    padding: 28px;
    .borderB();
    h2 {
      font-size: 32px;
      color: rgba(24, 24, 24, 1);
      line-height: 44px;
      height: 88px;
      margin-bottom: 18px;
      word-break: break-all;
    }
    .item_bottom {
      .flex();
      align-items: center;
      .item_bottom_left {
        font-size: 28px;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
      }
      .item_bottom_labal {
        flex: 1;
        .flex();
        justify-content: flex-end;
        span {
          display: block;
          margin-left: 10px;
          // min-width: 160px;
          padding:0 10px;
          background: rgba(235, 239, 245, 1);
          border-radius: 4px;
          font-size: 24px;
          color: rgba(60, 100, 159, 1);
          line-height: 34px;
          text-align: center;
        }
      }
    }
  }
</style>